// Analytics configuration
export const ANALYTICS_CONFIG = {
  // Replace with your actual Google Analytics Measurement ID
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-5Q0W3N65QE',
  
  // Enable/disable analytics (useful for development)
  ENABLED: process.env.NODE_ENV === 'production',
  
  // Custom event names
  EVENTS: {
    PAGE_VIEW: 'page_view',
    GAME_START: 'game_start',
    CLUE_REVEAL: 'clue_reveal',
    PROPOSAL_SUBMISSION: 'proposal_submission',
    GAME_COMPLETION: 'game_completion',
    SOLUTION_REVEAL: 'solution_reveal',
    USER_INTERACTION: 'user_interaction',
    DAILY_ACTIVE_USER: 'daily_active_user'
  }
}; 